import {css} from '@emotion/core'
import styled from '@emotion/styled'
import { FontNormal } from '@css/fonts'
import { fontSize } from '@css/styles'
import {marketingMobileCuttoff, white} from "@css/constants";

export const BannerSectionContainer = styled('div')(css`
  height: auto;
  background-color: #5dcd82;
`)

export const BannerSectionTitle = styled('h3')(css`
  ${fontSize(36)};
  ${FontNormal(800)};
  color: ${white};
  text-align: center;
  text-transform: uppercase;
  
  @media(max-width: ${marketingMobileCuttoff}) {
    text-align: start;
    padding: 0 20px;
  }
`)

export const BannerSectionSubtitle = styled('h3')(css`
  ${fontSize(24)};
  ${FontNormal(400)};
  padding: 20px 0;
  text-align: center;
  color: ${white};
  
  @media(max-width: ${marketingMobileCuttoff}) {
    text-align: start;
    padding: 20px 20px;
  }
`)

export const BannerSectionWrapper = styled('div')(css`
  padding-top: 70px;
  padding-bottom: 70px;
`)
